import { useMemo, useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { paginationDefaultValues } from './constants.js';
import { PaginationDefaultValue } from './types.js';
export const usePagination = (limit) => {
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG]);
    // Changing the page size sends the reader back to the first page, because the old page index
    // addresses different rows once they are redistributed. An unchanged size is a no-op — `Select`
    // re-fires `onChange` for the option that is already selected.
    const updatePerPage = useCallbackRef((value) => {
        if (value === perPage) {
            return;
        }
        setPerPage(value);
        setPage(0);
    });
    const nextPage = useCallbackRef(() => {
        setPage((prev) => prev + 1);
    });
    const prevPage = useCallbackRef(() => {
        setPage((prev) => prev - 1);
    });
    return useMemo(() => ({
        page,
        setPage,
        nextPage,
        prevPage,
        perPage,
        setPerPage: updatePerPage,
    }), [page, perPage, nextPage, prevPage, updatePerPage]);
};
